import userCreativesTpl from '../templates/creatives/user_creatives.directive.html';

export default function userCreatives() {
  return {
    restrict: 'EA',
    template: userCreativesTpl,
    controller: 'UserCreativesController',
    controllerAs: 'userCreativesVm'
  };
}
